
import { defineComponent, ref } from "vue";
import Modal from "./Modal.vue";
import TextareaInput from "../application/inputs/TextareaInput.vue";
import TextInput from "../application/inputs/TextInput.vue";
import SendButton from "../application/buttons/SendButton.vue";
import { useStore } from "vuex";
import { dispatchError } from "../../utils/error_handling";
import { dispatchSuccessBox } from "../mixins";

export default defineComponent({
  name: "Suggestion",
  components: { SendButton, TextInput, TextareaInput, Modal },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  setup(props, { emit }) {
    const store = useStore();

    const title = ref<string>("");
    const description = ref<string>("");

    const onSubmit = async (): Promise<void> => {
      try {
        await store.dispatch("suggestion_module/suggestion", {
          title: title.value,
          description: description.value
        });

        title.value = "";
        description.value = "";
        await dispatchSuccessBox("Sugestão enviada!");

        emit("toggle");
      } catch (e) {
        await dispatchError(e);
      }
    };

    return {
      title,
      description,
      onSubmit
    };
  }
});
